const logs = {
  title: "Logger",
  details: "Log Details",
  id: "ID",
  user_id: "Bruker",
  action: "Hendelse",
  action_model: "Hendelsestype",
  action_id: "Hendelses ID",
  record: "Record",
  ip_address: "IP adresse",
  created_at: "Dato",
  field: "Felt",
  before_values: "Opprinnelig",
  after_values: "Endret",
}
export default logs
